<template>
	<b-modal ref="modal" title="Purchase" :busy="loading>0">
		<b-skeleton-wrapper :loading="loading>0 && !purchase.price">
			<template #loading>
				<b-form-row class="mb-5">
					<b-col>
						<b-skeleton width="85%"></b-skeleton>
						<b-skeleton width="95%"></b-skeleton>
					</b-col>
					<b-col>
						<b-skeleton width="75%"></b-skeleton>
						<b-skeleton width="55%"></b-skeleton>
					</b-col>
					<b-col>
						<b-skeleton width="70%"></b-skeleton>
						<b-skeleton width="90%"></b-skeleton>
					</b-col>
				</b-form-row>
			</template>

			<b-form-row class="mb-3" variant="danger" v-show="purchase.price">
				<b-col>
					<b-form-group label="Price"><b-badge variant="primary">{{purchase.price}} {{purchase.currency}}</b-badge></b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Plan"><b-badge variant="primary">{{purchase.plan}}</b-badge></b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Period"><b-badge variant="primary">{{purchase.period}}</b-badge></b-form-group>
				</b-col>
			</b-form-row>
		</b-skeleton-wrapper>
		<stripe-element-payment
			v-if="purchase.elementsOptions.clientSecret"
			ref="paymentElement"
			:pk="pk"
			:elements-options="purchase.elementsOptions"
			:confirm-params="{}"
			:test-mode="true"
			redirect="if_required"
			@error="setError($event)"
			@confirmed="paymentConfirmed($event)"
			@loading="loading+=($event?1:-1)"
		/>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{ cancel }">
			<div class="w-100">
				<div class="float-right">
					<b-spinner v-show="loading>0" small label="Spinning" class="mr-3"></b-spinner>
					<b-button variant="success" type="submit" @click="submitPayment()" class="mr-2">
						Pay
					</b-button>
					<b-button @click="cancel()">
						Close
					</b-button>
				</div>
			</div>
		</template>
	</b-modal>
</template>

<script>
import { StripeElementPayment } from '@vue-stripe/vue-stripe';

export default {
	components: {
		StripeElementPayment
	},
	data: () => ({
		loading: 0,
		error: null,
		pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
		purchase: {
			plan: 'regular',
			period: 'monthly',
			price: null,
			currency: null,
			elementsOptions: {
				redirect: 'if_required',
				clientSecret: null,
				colorDanger: 'red',
			},
		},
	}),
	methods: {
		async show(plan, period) {
			try {
				this.error = null;
				this.loading++;
				this.purchase.plan = plan;
				this.purchase.period = period;
				this.purchase.price = null;
				this.purchase.currency = null;
				this.$refs.modal.show();
				const result = await this.$api.post('paymentIntent', { plan, period });
				this.purchase.price = result.price;
				this.purchase.currency = result.currency.toString().toUpperCase();
				this.purchase.elementsOptions.clientSecret = result.client_secret;
			} catch(e) {
				console.error('show error', e);
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		submitPayment() {
			this.error = null;
			this.$refs.paymentElement.submit();
		},
		paymentConfirmed() {
			this.error = null;
			this.$refs.modal.hide();
			this.$bvToast.toast('Payment succeeded! Thank you for your purchase.', {
				title: 'Success',
				variant: 'success',
				solid: true,
			});
			this.$emit('success');
		},
		setError($event) {
			console.error('stripe error', $event);
			this.error = `${$event.message} (${$event.code})`;
		},
	},
}
</script>
